import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { GeneralDataService } from '../../../../services/general-data-service';

@Component({
  selector: 'app-hm-portal-custom-fields',
  templateUrl: './hm-portal-custom-fields.component.html',
  styleUrls: [],
  standalone: false
})
export class HMPortalCustomFieldsComponent implements OnInit, OnChanges {
  @Input() settings: any;
  public defaultFields = [
    { key: 'about', value: 'About' },
    { key: 'survey', value: 'Survey' },
    { key: 'campaign', value: 'Campaign' }
  ];
  public selectedDefaultFields: any[] = [];
  public customFields: any[] = [];
  public selectedFields: any[] = [];

  constructor(private generalDataService: GeneralDataService) {}

  ngOnInit(): void {
    this.generalDataService.getCustomFields('all').subscribe((res: any) => {
      this.customFields = res.body || [];
    });
  }

  ngOnChanges(): void {
    if (this.settings) {
      this.selectedFields = this.settings.hmPortalCustomFields
        ? [...this.settings.hmPortalCustomFields]
        : [];

      this.selectedDefaultFields = this.settings.hmPortalDefaultFields
        ? [...this.settings.hmPortalDefaultFields]
        : [];
    }
  }

  isDefaultFieldSelected(field: any): boolean {
    return this.selectedDefaultFields.some(selected => selected.key === field.key);
  }

  toggleDefaultSelection(field: any, event: any): void {
    if (event.checked) {
      if (!this.isDefaultFieldSelected(field)) {
        this.selectedDefaultFields.push({
          key: field.key,
          value: field.value
        });
      }
    } else {
      const index = this.selectedDefaultFields.findIndex(
        selected => selected.key === field.key
      );

      if (index >= 0) {
        this.selectedDefaultFields.splice(index, 1);
      }
    }
  }

  isFieldSelected(field: any): boolean {
    return this.selectedFields.some(selected => selected.hash === field.hash);
  }

  toggleSelection(field: any, event: any): void {
    if (event.checked) {
      if (!this.isFieldSelected(field)) {
        this.selectedFields.push({
          key: field.key,
          value: field.value,
          hash: field.hash
        });
      }
    } else {
      const index = this.selectedFields.findIndex(selected => selected.hash === field.hash);
      if (index >= 0) {
        this.selectedFields.splice(index, 1);
      }
    }
  }

  getValues() {
    return {
      hmPortalDefaultFields: this.selectedDefaultFields,
      hmPortalCustomFields: this.selectedFields
    };
  }
}
